// src/app/core/services/admin-alerts.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AdminAlertsService {
    private apiUrl = `${environment.apiUrl}/api/admin-alerts`;

    constructor(private http: HttpClient) { }

    getAlerts(params?: any): Observable<any> {
        let httpParams = new HttpParams();
        if (params) {
            Object.keys(params).forEach(key => {
                if (params[key] !== null && params[key] !== undefined) {
                    httpParams = httpParams.set(key, params[key]);
                }
            });
        }
        return this.http.get(this.apiUrl, { params: httpParams });
    }

    getUnreadCount(): Observable<any> {
        return this.http.get(`${this.apiUrl}/unread-count`);
    }

    markAsRead(alertId?: number): Observable<any> {
        const body = alertId ? { alert_id: alertId } : { mark_all: true };
        return this.http.post(`${this.apiUrl}/mark-read`, body);
    }
}
